/**
 * Host login URL when inner React Router basename is `theme.path` or "" (special flows).
 * Kept separate from MF sync so React and non-React code can share the same rules.
 */

const PATHS_USING_ROOT_LOGIN = new Set([
  'abbonamenti',
  'esercizio_conferma',
  'download-pdf',
  'reset_password',
  'recover_password',
]);

export function assignWindowLocationToHostLogin() {
  if (typeof window === 'undefined') return;

  const first = window.location.pathname.split('/').filter(Boolean)[0];

  if (!first || first === 'login') {
    window.location.assign('/login');
    return;
  }

  if (PATHS_USING_ROOT_LOGIN.has(first)) {
    window.location.assign('/login');
    return;
  }

  window.location.assign(`/${first}/login`);
}
